<template>
  <v-dialog
    v-model="isOpen"
    width="650"
    @click:outside="$emit('close')"
  >
    <v-card class="d-flex flex-column align-items-center p-2">
      <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
      <v-card-title class="mb-4">
        <h4>Alerta!</h4>
      </v-card-title>
      <v-card-text class="text-center">
        <h6>Esse animal não pode ser encerrado por essa causa, pois possui menos de 210 dias de duração de lactação.</h6>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalAlertInterval",
  props:{
    isOpen:Boolean
  }
}
</script>

<style scoped>
.close-icon {
  right: 10px;
  top: 10px;
  position: absolute;
  font-size: 1.3rem;
  cursor: pointer;
}
</style>